import SvgRender from 'common/components/general/SvgRender';
import deactivate from 'common/assets/svg/actions/deactivate.svg';

const TopFilters = ({ setTopFilters, topFilters }) => {
  const activeSwitch = value => {
    setTopFilters(topFilters.map(f => (f.name === 'active' ? { ...f, value: value } : f)));
  };

  return (
    <div className="d-flex">
      {topFilters.find(f => f.name === 'active').value === false ||
      topFilters.find(f => f.name === 'active').value === null ? (
        <div
          onClick={() => activeSwitch('false')}
          className="d-inline-flex align-items-center text-primary cursor-pointer"
        >
          <SvgRender src={deactivate} style={{ width: 14, height: 14 }} className="me-1" />
          <div className="lh-1 fs-10 fw-normal">See inactive users</div>
        </div>
      ) : (
        <div onClick={() => activeSwitch(false)} className="fs-10 d-inline-flex align-items-center">
          <div className="d-inline-flex align-items-center cursor-pointer back-to-list">
            Back to List
          </div>
          <div className="text-primary">Inactive</div>
        </div>
      )}
    </div>
  );
};

export default TopFilters;
